import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ConvertMembershipDrawerState {
  isConvertMembership: {
    isOpen: boolean;
    previousPath: string | null;
  };
  selectedEmployeruuid: string | null;
  selectedDependentUuid: string | null;
  selectedUserUuid: string | null;
  hasPendingMembership: boolean;
  pendingMembershipData: Record<string, any> | null;
}

const initialState: ConvertMembershipDrawerState = {
  isConvertMembership: {
    isOpen: false,
    previousPath: null,
  },
  selectedEmployeruuid: null,
  selectedDependentUuid: null,
  selectedUserUuid: null,
  hasPendingMembership: false,
  pendingMembershipData: null,
};

const convertMembershipSlice = createSlice({
  name: "convertMembershipDrawer",
  initialState,
  reducers: {
    openDrawer: (
      state,
      action: PayloadAction<{ isOpen: boolean; previousPath: string | null }>,
    ) => {
      state.isConvertMembership.isOpen = action.payload.isOpen;
      state.isConvertMembership.previousPath = action.payload.previousPath;
    },
    setSelectedEmployerUuid: (state, action: PayloadAction<string>) => {
      state.selectedEmployeruuid = action?.payload;
    },
    setSelectedDependentUuid: (state, action: PayloadAction<string>) => {
      state.selectedDependentUuid = action?.payload;
    },
    setSelectedUserUuid: (state, action: PayloadAction<string>) => {
      state.selectedUserUuid = action?.payload;
    },
    setHasPendingMembership: (state, action: PayloadAction<boolean>) => {
      state.hasPendingMembership = action.payload;
    },
    setPendingMembership: (
      state,
      action: PayloadAction<Record<string, any> | null>,
    ) => {
      state.pendingMembershipData = action.payload;
    },
  },
});

export const {
  openDrawer,
  setSelectedEmployerUuid,
  setSelectedDependentUuid,
  setSelectedUserUuid,
  setHasPendingMembership,
  setPendingMembership,
} = convertMembershipSlice.actions;
export default convertMembershipSlice.reducer;
